import { Box, Grid, Typography } from "@mui/material";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import { EnhancedButtonPrimeReact, EnhancedButtonPrimeReactSeverity, IDropableItemData } from "@websential/cosmic-v20";
import React, { FC } from "react";

import { MoveEmployeeFirstPanel } from "./MoveEmployeeFirstPanel";
import { MoveEmployeeSecondPanel } from "./MoveEmployeeSecondPanel";
import { sortDragDropContextDDLByName } from "../../../common/Common";

export interface IPayrollAdjustmentAddEmployeePanel {
	assignedAddEmployeeResponsePayload: any;
	assignedAddEmployeeResponseData: any;
	moveEmployeeFirstPanelSelectionToolbar: any;
	moveEmployeeSecondPanelSelectionToolbar: any;
	onMoveAssignEmployeeClicked: () => void;
	onMoveUnAssignedEmployeeClicked: () => void;
	isLoadingAddEmployee: boolean;
	isLoadingRemoveEmployee: boolean;
	moveEmployeeFirstPanelItems: any
	moveEmployeeSecondPanelItems: any
}
const moveEmployeeFirstPanelUpdatedColumns = [
	{
		field: "name",
		headerName: `Select / Un-select All Employee(s)`,
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: true,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 0,
		frozenColumn: false,
		footer: null,
	},
];
export const PayrollAdjustmentAddEmployeePanel: FC<
	IPayrollAdjustmentAddEmployeePanel
> = ({
	assignedAddEmployeeResponsePayload,
	assignedAddEmployeeResponseData,
	moveEmployeeFirstPanelSelectionToolbar,
	moveEmployeeSecondPanelSelectionToolbar,
	onMoveAssignEmployeeClicked,
	onMoveUnAssignedEmployeeClicked,
	isLoadingAddEmployee,
	isLoadingRemoveEmployee,
	moveEmployeeFirstPanelItems,
	moveEmployeeSecondPanelItems
}) => {
		return (
			<Grid
				container
				columnSpacing={2}
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{ width: "100%" }}
			>
				<Grid size={{ xs: 5, sm: 5, md: 5, lg: 5, xl: 5 }}>
					<Box>
						<MoveEmployeeFirstPanel
							columns={
								assignedAddEmployeeResponsePayload && moveEmployeeFirstPanelUpdatedColumns
							}
							rows={
								assignedAddEmployeeResponsePayload &&
								// assignedAddEmployeeResponseData.assigned.length !== 0 &&
								sortDragDropContextDDLByName(assignedAddEmployeeResponseData.assigned)
							}
							selectionToolbar={moveEmployeeFirstPanelSelectionToolbar}
						/>
					</Box>
				</Grid>
				<Grid
					size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Box sx={{ display: "flex", flexDirection: "column" }}>
						<EnhancedButtonPrimeReact
							// icon={isLoadingAddOrRemoveEmployee && </>}
							onClickHandler={onMoveAssignEmployeeClicked}
							loading={isLoadingAddEmployee}
							// size="small"
							label="Add"
							severity={EnhancedButtonPrimeReactSeverity.Success}
							raised
							disabled={
								moveEmployeeFirstPanelItems &&
									moveEmployeeFirstPanelItems.length > 0
									? false
									: true
							}
							style={{ justifyContent: "center" }}
						/>
						<br />
						<EnhancedButtonPrimeReact
							// icon="pi pi-angle-double-left"
							onClickHandler={onMoveUnAssignedEmployeeClicked}
							loading={isLoadingRemoveEmployee}
							// size="small"
							label="Remove"
							severity={EnhancedButtonPrimeReactSeverity.Danger}
							raised
							disabled={
								moveEmployeeSecondPanelItems &&
									moveEmployeeSecondPanelItems.length > 0
									? false
									: true
							}
						/>
					</Box>
				</Grid>
				<Grid size={{ xs: 5, sm: 5, md: 5, lg: 5, xl: 5 }}>
					<Box>
						<MoveEmployeeSecondPanel
							columns={
								assignedAddEmployeeResponsePayload && moveEmployeeFirstPanelUpdatedColumns
							}
							rows={
								assignedAddEmployeeResponsePayload &&
								// assignedAddEmployeeResponseData.unassigned.length !== 0 &&
								sortDragDropContextDDLByName(assignedAddEmployeeResponseData.unassigned)
							}
							selectionToolbar={moveEmployeeSecondPanelSelectionToolbar}
						/>
					</Box>
				</Grid>
			</Grid>
		);
	};
